import { project } from '@/+state';

export const isMiscLoading = project<boolean>(
  ({ stores }) => !!stores.miscStore.loading.length,
);

export const miscProjections = [isMiscLoading];
